var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"id":"back-btn"},on:{"click":_vm.goBack}},[_c('icon',{attrs:{"data":require("@icon/navigate-before.svg"),"width":"24","height":"24"}}),_vm._v("Home")],1)}
var staticRenderFns = []

export { render, staticRenderFns }